import { ApiResult, HttpClient } from "../http.js";
import { TradeDto } from "../types/trades.js";

export interface CreateTradePayload {
  name: string;
}

export interface ListTradesQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface PagedTrades {
  items: TradeDto[];
  page: number;
  pageSize: number;
  total: number;
}

export class TradesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListTradesQuery = {}): Promise<ApiResult<PagedTrades>> {
    return this.http.get<PagedTrades>("/api/trades", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<TradeDto>> {
    return this.http.get<TradeDto>(`/api/trades/${encodeURIComponent(id)}`);
  }

  create(payload: CreateTradePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/trades", { body: payload });
  }
}
